import { render, staticRenderFns } from "./changeCard.vue?vue&type=template&id=606c709a&scoped=true&"
import script from "./changeCard.vue?vue&type=script&lang=js&"
export * from "./changeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c709a",
  null
  
)

export default component.exports